export const LIST_ITEM_TYPE_PRODUCT = 'PRODUCT';
export const LIST_ITEM_TYPE_VARIANT = 'VARIANT';
export const LIST_ITEM_TYPE_BANNER = 'BANNER';

export const LIST_TYPE_FLASH_SALE = 'flashsale';
export const LIST_TYPE_BUNDLE_DEALS = 'bundleDeals';
export const LIST_TYPE_BONUS_ITEM = 'bonusItem';

